import React, { useState } from "react";

//@ts-ignore
import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useJsApiLoader,
} from "@react-google-maps/api";
import {
  Detail,
  CardSumary,
  FilterCard,
  TableCard,
  BtnBi,
  UserModal,
  Simbologia,
  IconoSimbologia,
} from "./components";
import "../index.css";
import {
  cmbEstado,
  cmbCiudad,
  cmbUsuario,
  cmbProfiles,
  cmbSucursal,
  getStoresActive,
  getSumary,
  getStoreDetail,
} from "actions/portalClientes";

import FilterValues from "./types/FilterValues";
import SumryTypes from "./types/SumaryTypes";
import UserDeatilType from "./types/UserDetailType";
import { useNavigate } from "react-router-dom";
import { hotToast } from "utils";

export const WrapperMap = ({ REACT_APP_API_KEY_MAPS, refresh }: any) => {
  const history = useNavigate();
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: REACT_APP_API_KEY_MAPS,
  });

  const [zoom, setZoom] = React.useState(6);

  const [center, setCenter] = React.useState({
    lat: 24.436161,
    lng: -102.137314,
  });

  const containerStyle = {
    width: "100wh",
    height: "100%",
  };

  function handleZoomChanged(): void {
    // setZoom(this.getZoom()); //this refers to Google Map instance
  }

  const [openModal, setOpenModal] = React.useState(false);
  const [openDetail, setOpenDetail] = React.useState(false);

  const [states, setState] = React.useState<Array<any>>([]);
  const [citys, setCitys] = React.useState<Array<any>>([]);
  const [users, setUsers] = React.useState<Array<any>>([]);
  const [profiles, setProfiles] = React.useState<Array<any>>([]);
  const [sucursales, setSucursales] = React.useState<Array<any>>([]);
  const [valuesFilter, setValuesFilter] = useState<FilterValues>({
    estado: null,
    ciudad: null,
    usuarios: null,
    perfiles: null,
    sucursales: null,
  });

  const [sumary, setSumary] = useState<SumryTypes>();
  const [storesActives, setStoresActives] = React.useState<Array<any>>([]);
  const [isRequest, setIsRequest] = React.useState<boolean>(false);
  const [detail, setDetail] = React.useState<any>();
  const [selectedUser, setSelectedUser] = React.useState<UserDeatilType>({
    name: null,
    assistance: null,
    closeAssistance: null,
    id: null,
  });

  const filters: Object = React.useMemo(() => {
    return {
      estado: states,
      ciudad: citys,
      usuarios: users,
      perfiles: profiles,
      //sucursales: sucursales,
    };
  }, [states, citys, users, profiles, sucursales]);

  React.useEffect(() => {
    (async () => {
      const resultState = await cmbEstado();
      if (resultState) setState(resultState);

      const resultUser = await cmbUsuario();
      if (resultUser) setUsers(resultUser);

      const resultProfiles = await cmbProfiles();
      if (resultProfiles) setProfiles(resultProfiles);

      const resultSucursales = await cmbSucursal();
      if (resultSucursales) setSucursales(resultSucursales);
    })();
  }, []);

  React.useEffect(() => {
    (async () => {
      if (!valuesFilter?.estado) {
        setCitys([]);
        return;
      }
      //@ts-ignore
      const resultCity = await cmbCiudad(valuesFilter?.estado.id);
      if (resultCity) {
        setCitys(resultCity);
      }
    })();
  }, [valuesFilter]);

  React.useEffect(() => {
    if (refresh || valuesFilter) {
      (async () => {
        const resultStores = await getStoresActive(valuesFilter);
        if (resultStores) {
          setStoresActives(resultStores);
        }

        const resultSumary = await getSumary();
        if (resultSumary) setSumary(resultSumary);
      })();
    }
  }, [refresh, valuesFilter]);

  const handleDetail = ({ location }: any) => {
    if (isRequest) return;
    setIsRequest(true);
    getStoreDetail(location.id).then((_detail) => {
      setIsRequest(false);
      if (!_detail || Object.keys(_detail).length === 0) {
        setOpenDetail(false);
        setDetail({});
        hotToast("La consulta no arrojo detalles", "WAR", 2000);
        return;
      }
      setOpenDetail(true);
      setDetail(_detail);
    });
  };

  const renderMarkets = (locations: any, clusterer: any) => {
    if (!locations) return null;
    return locations.map((location: any, index: number) => {
      const total = location.supervisor + location.demonstrators;
      const isSelect = location.id === detail?.id;
      const icon = isSelect
        ? "green.png"
        : total > 0
          ? "yellow.png"
          : "red.png";
      return (
        <Marker
          position={{
            lat: location.lat,
            lng: location.lon,
          }}
          key={location.lat + location.lon + index + "b"}
          icon={`http://maps.google.com/mapfiles/ms/icons/${icon}`}
          onClick={() => handleDetail({ location })}
          title={location.name}
        />
      );
    });
  };

  const handleOnChangeFilter = ({
    type,
    value,
  }: {
    type: string;
    value: number;
  }) => {
    if (openDetail) {
      setOpenDetail(false);
      setDetail({});
    }
    if (type === "estado") {
      //@ts-ignore
      setValuesFilter({ ...valuesFilter, [type]: value, ciudad: null });
      return;
    }
    //@ts-ignore
    setValuesFilter({ ...valuesFilter, [type]: value });
  };
  if (isLoaded) {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        options={{
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
        onZoomChanged={handleZoomChanged}
      >
        {storesActives && storesActives.length > 0
          ? renderMarkets(storesActives, null)
          : null}

        {openDetail && (
          <Detail
            detail={detail}
            handleOpenUserDetail={({ initIndex }: { initIndex: number }) => {
              if (detail && detail.users) {
                setSelectedUser(detail?.users[initIndex] as UserDeatilType);

                setOpenModal(true);
              }
            }}
          />
        )}

        {openModal && (
          <UserModal
            setOpenModal={setOpenModal}
            users={detail.users}
            handleOnChangeUserIndex={(index: number) => {
              if (detail && detail.users) {
                setSelectedUser(detail.users[index] as UserDeatilType);
              }
            }}
            selectedUser={selectedUser}
            nameStore={detail?.name || ""}
          />
        )}

        <BtnBi
          onClick={() => {
            history && history(-1);
          }}
        />
        <CardSumary
          supervisor={sumary?.supervisor || 0}
          demonstrators={sumary?.demonstrators || 0}
        />
        <FilterCard
          filters={filters}
          handleOnChange={handleOnChangeFilter}
          values={valuesFilter}
        />
        <TableCard
          setCenter={setCenter}
          setZoom={setZoom}
          tiendas={storesActives}
          handleSelectedStore={({ lat, lng }: { lat: number; lng: number }) => {
            if (openDetail) {
              setOpenDetail(false);
            }
            setZoom(12);
            setCenter({ lat, lng });
          }}
        />
        <Simbologia />
      </GoogleMap>
    );
  }
  return (
    <div className="grid place-items-center w-full h-full">
      <h1 className="text-lg font-bold text-[#2b2b2b]">Cargando Mapa</h1>
    </div>
  );
};
